module.exports = __webpack_public_path__ + "img/eg.ee8d7549.svg";